import {Component, OnInit, OnDestroy, HostListener} from '@angular/core';
import {OperationService} from "./operation.service";
import {Subscription} from "rxjs/Subscription";
import {OperateInfo, OperationState} from "./operate";
import {SlideInOutAnimation} from "../_animations/slide-in-out.animation";
import {TranslateService} from "@ngx-translate/core";


@Component({
  selector: 'hbr-operation-model',
  template: `<div class="operDiv" [@SlideInOutAnimation]="animationState">
    <a class="toolBar" (click)="slideOut()">{{'OPERATION.EVENT_LOG' | translate}}<!--<clr-icon shape="angle-double" style="transform: rotate(90deg)"></clr-icon>--></a>
    <div class="side-form">
        <clr-icon shape="refresh" class="freshIcon" (click)="TabEvent()"></clr-icon>
        <h3 class="custom-h2" style="margin-left: 34px;">{{'OPERATION.LOCAL_EVENT' | translate}}</h3>
        <div style="margin-top: 10px;">
            <clr-tabs>
                <clr-tab>
                    <button clrTabLink id="link1" (click)="TabEvent()">{{'OPERATION.ALL' | translate}}</button>
                    <clr-tab-content id="contentAll" *clrIfActive="true">
                        <div class="eventInfo" *ngFor="let list of resultLists">
                            <div class="iconsArea">
                                <i class="spinner spinner-inline spinner-pos" [hidden]="list.state != 'progressing'"></i>
                                <clr-icon [hidden]="list.state != 'success'" size="18" shape="success-standard" style="color: green"></clr-icon>
                                <clr-icon [hidden]="list.state != 'failure'" size="18"  shape="error-standard" style="color: red"></clr-icon>
                                <clr-icon [hidden]="list.state != 'interrupt'" size="18"  shape="unlink" style="color: orange"></clr-icon>
                            </div>
                            <div class="infoArea">
                                <label class="eventName" (click)="toggleTitle(spanErrorInfo)">{{list.name | translate}}</label>
                                <span class="eventTarget">{{list.data.name}}</span><span class="eventTime">{{list.timeDiff | translate}}</span>
                                <span #spanErrorInfo class="eventErrorInf" style="display: none;">{{list.data.errorInf}}</span>
                            </div>
                        </div>
                    </clr-tab-content>
                </clr-tab>
                <clr-tab>
                    <button clrTabLink (click)="TabEvent()">{{'OPERATION.RUNNING' | translate}}</button>
                    <clr-tab-content id="contentRun" *clrIfActive>
                        <div class="eventInfo" *ngFor="let list of runningLists">
                            <div class="iconsArea">
                                <i class="spinner spinner-inline spinner-pos" [hidden]="list.state != 'progressing'"></i>
                                <clr-icon [hidden]="list.state != 'success'" size="18" shape="success-standard" style="color: green"></clr-icon>
                                <clr-icon [hidden]="list.state != 'failure'" size="18"  shape="error-standard" style="color: red"></clr-icon>
                            </div>
                            <div class="infoArea">
                                <label class="eventName" (click)="toggleTitle(spanErrorInfo)">{{list.name | translate}}</label>
                                <span class="eventTarget">{{list.data.name}}</span><span class="eventTime">{{list.timeDiff | translate}}</span>
                                <span #spanErrorInfo class="eventErrorInf" style="display: none;">{{list.data.errorInf}}</span>
                            </div>
                        </div>
                    </clr-tab-content>
                </clr-tab>
                <clr-tab>
                    <button clrTabLink (click)="TabEvent()">{{'OPERATION.FAILED' | translate}}</button>
                    <clr-tab-content id="contentFailed" *clrIfActive>
                        <div class="eventInfo" *ngFor="let list of failLists">
                            <div class="iconsArea">
                                <i class="spinner spinner-inline spinner-pos" [hidden]="list.state != 'progressing'"></i>
                                <clr-icon [hidden]="list.state != 'success'" size="18" shape="success-standard" style="color: green"></clr-icon>
                                <clr-icon [hidden]="list.state != 'failure'" size="18"  shape="error-standard" style="color: red"></clr-icon>
                            </div>
                            <div class="infoArea">
                                <label class="eventName" (click)="toggleTitle(spanErrorInfo)">{{list.name | translate}}</label>
                                <span class="eventTarget">{{list.data.name}}</span><span class="eventTime">{{list.timeDiff | translate}}</span>
                                <span #spanErrorInfo class="eventErrorInf" style="display: none;">{{list.data.errorInf}}</span>
                            </div>
                        </div>
                    </clr-tab-content>
                </clr-tab>
            </clr-tabs>
        </div>
    </div>
</div>

`,
  styles: [`.side-form{position:absolute;width:325px;height:100%;left:28px;padding-top:20px;background:#fff;border-left:1px solid #e0e0e0}.eventInfo{display:flex;justify-content:flex-start;align-content:flex-start;padding:8px 5px 8px 10px;border-bottom:1px solid #ccc}.iconsArea{flex-shrink:1}.infoArea{margin-left:10px;width:270px}.eventName{display:block;margin-bottom:-5px;font-size:16px;color:#0b7fbd}.eventErrorInf{display:block;font-size:12px;color:red;line-height:.6rem}.eventTarget{display:inline-flex;width:172px;font-size:12px;flex-shrink:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.eventTime{float:right;font-size:12px}:host>>>.nav{padding-left:38px}.operDiv{position:fixed;top:60px;right:0;z-index:100}.toolBar{float:left;border-top:1px solid #ccc;-webkit-transform:rotate(-90deg);transform:rotate(-90deg);margin-top:10px;padding:2px 4px;width:86px;height:84px;background-color:#fff;letter-spacing:1.2px;font-weight:500;box-shadow:-2px -1px 3px #bebbbb;cursor:pointer;text-align:center;text-decoration:none}.freshIcon{float:right;margin-right:20px;margin-top:-10px;cursor:pointer}#contentAll,#contentFailed,#contentRun{position:absolute;top:95px;bottom:0;width:100%;overflow-y:auto}`],
  animations: [SlideInOutAnimation],
})
export class OperationComponent implements OnInit, OnDestroy {
  batchInfoSubscription: Subscription;
  resultLists: OperateInfo[] = [];
  animationState = "out";

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHander(event) {
    // storage to localStorage
    let timp = new Date().getTime();
    localStorage.setItem('operaion', JSON.stringify({timp: timp,  data: this.resultLists}));
  }

  constructor(
    private operationService: OperationService,
    private translate: TranslateService) {

    this.batchInfoSubscription = operationService.operationInfo$.subscribe(data => {
      // this.resultLists = data;
      this.openSlide();
      if (data) {
        if (this.resultLists.length >= 50) {
          this.resultLists.splice(49, this.resultLists.length - 49);
        }
        this.resultLists.unshift(data);
      }
    });
  }

  public get runningLists(): OperateInfo[] {
    let runningList: OperateInfo[] = [];
    this.resultLists.forEach(data => {
      if (data.state === 'progressing') {
        runningList.push(data);
      }
    });
    return runningList;
  }

  public get failLists(): OperateInfo[] {
    let failedList: OperateInfo[] = [];
    this.resultLists.forEach(data => {
      if (data.state === 'failure') {
        failedList.push(data);
      }
    });
    return failedList;
  }

  ngOnInit() {
    let requestCookie = localStorage.getItem('operaion');
    if (requestCookie) {
      let operInfors: any = JSON.parse(requestCookie);
      if (operInfors) {
        if ((new Date().getTime() - operInfors.timp) > 1000 * 60 * 60 * 24) {
          localStorage.removeItem('operaion');
        }else {
          if (operInfors.data) {
            operInfors.data.forEach(operInfo => {
              if (operInfo.state === OperationState.progressing) {
                operInfo.state = OperationState.interrupt;
                operInfo.data.errorInf = 'operation been interrupted';
              }
            });
            this.resultLists = operInfors.data;
          }
        }
      }

    }
  }
  ngOnDestroy(): void {
    if (this.batchInfoSubscription) {
      this.batchInfoSubscription.unsubscribe();
    }
  }

  toggleTitle(errorSpan: any) {
    errorSpan.style.display = (errorSpan.style.display === 'none') ? 'block' : 'none';
  }

  slideOut(): void {
    this.animationState = this.animationState === 'out' ? 'in' : 'out';
  }

  openSlide(): void {
    this.animationState = 'in';
  }


  TabEvent(): void {
    let timp: any;
    this.resultLists.forEach(data => {
       timp = new Date().getTime() - +data.timeStamp;
       data.timeDiff = this.calculateTime(timp);
    });
  }

  calculateTime(timp: number) {
    let dist = Math.floor(timp / 1000 / 60);  // change to minute;
    if (dist > 0 && dist < 60) {
      return Math.floor(dist) + ' minute(s) ago';
    }else if (dist >= 60 && Math.floor(dist / 60) < 24) {
      return Math.floor(dist / 60) + ' hour(s) ago';
    } else if (Math.floor(dist / 60) >= 24)  {
      return Math.floor(dist / 60 / 24) + ' day ago';
    } else {
      return 'less 1 minute';
    }

  }

  /*calculateTime(timp: number) {
    let dist = Math.floor(timp / 1000 / 60);  // change to minute;
    if (dist > 0 && dist < 60) {
       return this.translateTime('OPERATION.MINUTE_AGO', Math.floor(dist));
    }else if (dist > 60 && Math.floor(dist / 60) < 24) {
      return this.translateTime('OPERATION.HOUR_AGO', Math.floor(dist / 60));
    } else if (Math.floor(dist / 60) >= 24 && Math.floor(dist / 60) <= 48)  {
      return this.translateTime('OPERATION.DAY_AGO', Math.floor(dist / 60 / 24));
    } else {
      return this.translateTime('OPERATION.SECOND_AGO');
    }
  }*/

  translateTime(tim: string, param?: number) {
    this.translate.get(tim, { 'param': param }).subscribe((res: string) => {
      return res;
    });
  }
}
